export class UnpySession {
  constructor(public readonly url: string) {}
}
